import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "../../env.config";
import { Token } from "../_models/token";
import atob from 'atob';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public tokenSubject: BehaviorSubject<Token>;
  public token: Observable<Token>;
  private refreshTokenTimeout;
  private authEmail: string = environment.auth.email;
  private authPassword: string = environment.auth.password;

  constructor(
    private http: HttpClient
  ) {
    this.tokenSubject = new BehaviorSubject<Token> (null);
    this.token = this.tokenSubject.asObservable();
  }

  public get tokenValue(): Token {
    return this.tokenSubject.value;
  }

  // Refresh token
  refreshToken(): any {
    return this.http.post<any>(`auth/login`, {
        email: this.authEmail,
        password: this.authPassword
      })
      .pipe(map((token) => {
        this.token = token;
        this.tokenSubject.next(token);
        this.startRefreshTokenTimer();

        return token;
      }));
  }

  // Start refresh token timer
  private startRefreshTokenTimer(): void {
    const token = JSON.parse(atob(this.tokenValue.access_token.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(token.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer(): void {
    clearTimeout(this.refreshTokenTimeout);
  }
}
